import $ from 'jquery';

const searchResultsInputInit = () => {
    const $searchInput = $('.search-input');

    if (!$searchInput) { return; }

    const submitSearch = searchTerm => {
        const newUrl = `${window.location.origin}/Search?searchtext=${encodeURI(searchTerm)}`;

        try {
            window.location = newUrl;
        } catch (e) { // catches a malformed URI
            // eslint-disable-next-line no-console
            console.error(e);
        }
    };

    $('.search-input .svg-icon').on('click', () => {
        submitSearch($('.search-input input').val());
    });

    $('.search-input input').on('keypress', e => {
        if (e.keyCode === 13) {
            submitSearch(e.target.value);
        }
    });
};

$(() => {
    searchResultsInputInit();
});
